import { render } from "./appointmentDetail.vue?vue&type=template&id=474c9486&scoped=true"
import script from "./appointmentDetail.vue?vue&type=script&lang=js"
export * from "./appointmentDetail.vue?vue&type=script&lang=js"

import "./appointmentDetail.vue?vue&type=style&index=0&id=474c9486&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-474c9486"]])

export default __exports__